import React, { useEffect, useRef, useState } from "react";
import "./CompanyBanner.css";

import volvo from "../assets/images/volvo.png";
import boeing from "../assets/images/boeing.png";
import skf from "../assets/images/skf.png";
import ericsson from "../assets/images/ericsson.png";
import consilium from "../assets/images/consilium.png";
import haleytek from "../assets/images/haleytek.png";
import goteborgsstad from "../assets/images/goteborgsstad.png";
import hyfer from "../assets/images/hyfer.png";
import esab from "../assets/images/esab.png";
import zeekr from "../assets/images/zeekr.png";

/**
 * Each logo has bespoke width / height / opacity from Figma.
 * Mobile responsive sizes are handled via CSS media queries.
 */
const logos = [
  { src: volvo, w: 140.742, h: 20, opacity: 0.27 },
  { src: boeing, w: 221.849, h: 66, opacity: 0.24 },
  { src: skf, w: 132.604, h: 36, opacity: 0.32 },
  { src: ericsson, w: 202.353, h: 43, opacity: 0.24 },
  { src: consilium, w: 221, h: 34, opacity: 1 },
  { src: haleytek, w: 181, h: 36, opacity: 1 },
  { src: goteborgsstad, w: 185, h: 81, opacity: 1 },
  { src: hyfer, w: 105, h: 46, opacity: 1 },
  { src: esab, w: 141, h: 141, opacity: 1 },
  { src: zeekr, w: 163, h: 41, opacity: 1 },
];

const CompanyBanner = () => {
  const [animate, setAnimate] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const bannerRef = useRef(null);

  // Check if device is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimate(true);
          observer.disconnect();
        }
      },
      {
        root: null,
        threshold: 0,
        rootMargin: isMobile ? "0px 0px -15% 0px" : "0px 0px -25% 0px"
      }
    );

    if (bannerRef.current) observer.observe(bannerRef.current);
    return () => observer.disconnect();
  }, [isMobile]);

  // Create exact duplicates for seamless infinite scroll
  const scrollingLogos = [...logos, ...logos, ...logos];

  return (
    <section className="company-banner-section" ref={bannerRef}>
      <div className={`logo-strip ${animate ? "animate" : ""}`}>
        {scrollingLogos.map(({ src, w, h, opacity }, idx) => (
          <img
            key={idx}
            src={src}
            alt="company logo"
            style={{
              width: isMobile ? 'auto' : `${w}px`,
              height: isMobile ? `${h * 0.6}px` : `${h}px`,
              opacity
            }}
            className="company-logo"
            loading="lazy"
          />
        ))}
      </div>
    </section>
  );
};

export default CompanyBanner;